import React, { useState, useEffect } from 'react';
import { mailingApiService } from '../../api/mailingApi';
import { usersAPI } from '../../api/api';
import MailingModal from '../../components/modals/MailingModal';

const MONTHS = [
  { name: 'OCAK - JANUARY', value: 0 },
  { name: 'ŞUBAT - FEBRUARY', value: 1 },
  { name: 'MART - MARCH', value: 2 },
  { name: 'NİSAN - APRIL', value: 3 },
  { name: 'MAYIS - MAY', value: 4 },
  { name: 'HAZİRAN - JUNE', value: 5 },
  { name: 'TEMMUZ - JULY', value: 6 },
  { name: 'AĞUSTOS - AUGUST', value: 7 },
  { name: 'EYLÜL - SEPTEMBER', value: 8 },
  { name: 'EKİM - OCTOBER', value: 9 },
  { name: 'KASIM - NOVEMBER', value: 10 },
  { name: 'ARALIK - DECEMBER', value: 11 }
];

const MailingCalendar = () => {
  const [year] = useState(2026);
  const [mailings, setMailings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMailing, setSelectedMailing] = useState(null);
  const [referenceData, setReferenceData] = useState({
    mailingGoals: [],
    targetMarkets: [],
    users: []
  });

  useEffect(() => {
    loadMailings();
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      // Get users from API
      const usersResponse = await usersAPI.getUsers();
      let usersList = [];
      if (usersResponse && usersResponse.success) {
        // Filter users who have ID 10 in department
        usersList = (usersResponse.data || [])
          .filter(u => u.department_id === 10 || u.department === 10)
          .map(u => ({
            ...u,
            name: u.full_name || u.email
          }));
      }

      // Demo referans verileri
      const demoGoals = [
        { id: 1, value: 'kutlama', label: 'kutlama' },
        { id: 2, value: 'özel günün kutlaması', label: 'özel günün kutlaması' },
        { id: 3, value: 'duyuru', label: 'duyuru' },
        { id: 4, value: 'Increase and promote sales', label: 'Increase and promote sales' }
      ];

      const demoMarkets = [
        { id: 1, value: 'Tüm Pazarlar', label: 'Tüm Pazarlar' },
        { id: 2, value: 'BDT', label: 'BDT' },
        { id: 3, value: 'Balkan+Baltık', label: 'Balkan+Baltık' },
        { id: 4, value: 'Müslüman ülkeler', label: 'Müslüman ülkeler' },
        { id: 5, value: 'Rus pazarı', label: 'Rus pazarı' },
        { id: 6, value: 'Türkiye pazarı', label: 'Türkiye pazarı' }
      ];

      setReferenceData({
        mailingGoals: demoGoals,
        targetMarkets: demoMarkets,
        users: usersList
      });
    } catch (err) {
      console.error('Reference data load error:', err);
    }
  };

  const loadMailings = async () => {
    try {
      setLoading(true);
      const response = await mailingApiService.getMailings();
      if (response && response.success) {
        setMailings(response.data || []);
      }
    } catch (err) {
      console.error('Mailings load error:', err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      ready: 'bg-green-500',
      in_progress: 'bg-yellow-500',
      pending: 'bg-orange-500',
      completed: 'bg-green-500'
    };
    return colors[status] || 'bg-gray-500';
  };

  const isWeekend = (day, monthIndex) => {
    const date = new Date(year, monthIndex, day);
    const d = date.getDay();
    return d === 0 || d === 6;
  };

  const getDaysInMonth = (monthIndex) => {
    const date = new Date(year, monthIndex + 1, 0);
    const days = [];
    for (let i = 1; i <= date.getDate(); i++) {
      days.push(i);
    }
    return days;
  };

  const getFirstDayOfWeek = (year, monthIndex) => {
    return new Date(year, monthIndex, 1).getDay();
  };

  const getRowCells = (mailingName, monthIndex, daysInMonth) => {
    const cells = [];
    const mailingEvents = mailings.filter(m => m.mailing_name === mailingName);
    const firstDay = getFirstDayOfWeek(year, monthIndex);

    // Empty cells for days before the first day
    for (let i = 0; i < firstDay; i++) {
      cells.push({ day: null, events: [] });
    }

    for (let day = 1; day <= daysInMonth.length; day++) {
      const currentDt = new Date(year, monthIndex, day);
      const checkDt = new Date(currentDt.getFullYear(), currentDt.getMonth(), currentDt.getDate());

      const eventsForDay = mailingEvents.filter(e => {
        if (!e.planned_date) return false;
        const mailingDate = new Date(e.planned_date);
        const mDate = new Date(mailingDate.getFullYear(), mailingDate.getMonth(), mailingDate.getDate());
        return checkDt.getTime() === mDate.getTime();
      });

      cells.push({ day, events: eventsForDay });
    }
    return cells;
  };

  const handleEventClick = (event, e) => {
    e.stopPropagation();
    setSelectedMailing(event);
    setIsModalOpen(true);
  };

  const handleSaveMailing = async (data) => {
    try {
      if (data.id) {
        await mailingApiService.updateMailing(data.id, data);
      } else {
        await mailingApiService.createMailing(data);
      }
      setIsModalOpen(false);
      setSelectedMailing(null);
      loadMailings();
    } catch (err) {
      console.error('Save error:', err);
    }
  };


  // Get unique mailing names
  const uniqueMailings = [...new Set(mailings.map(m => m.mailing_name))].filter(Boolean);

  return (
    <div className="px-3 py-4 sm:px-4 md:p-6 bg-white min-h-screen overflow-x-auto dark:bg-gray-900 select-none">
      <MailingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveMailing}
        initialData={selectedMailing}
        referenceData={referenceData}
      />

      <h1 className="text-2xl font-bold text-center mb-4 text-gray-900 dark:text-white uppercase tracking-wider">
        MAILING CALENDAR {year}
      </h1>

      <div className="flex flex-wrap justify-start md:justify-end gap-3 md:gap-6 text-xs font-bold mb-4">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-red-600 rounded"></div>
          <span className="text-gray-700 dark:text-gray-300">Cumartesi & Pazar</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-green-500 rounded"></div>
          <span className="text-gray-700 dark:text-gray-300">Hazır/Tamamlandı</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-orange-500 rounded"></div>
          <span className="text-gray-700 dark:text-gray-300">Beklemede</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-yellow-500 rounded"></div>
          <span className="text-gray-700 dark:text-gray-300">Yapılıyor</span>
        </div>
      </div>

      <div className="flex flex-col gap-10">
        {MONTHS.map((month) => {
          const days = getDaysInMonth(month.value);
          if (uniqueMailings.length === 0) return null;

          return (
            <div key={month.value} className="border-2 border-gray-800 dark:border-gray-500 shadow-sm">
              <div className="bg-[#9bc2e6] text-black font-extrabold text-center py-1.5 border-b-2 border-gray-800 text-sm tracking-wide">
                {month.name}
              </div>

              <table className="w-full border-collapse table-fixed text-[11px]">
                <colgroup>
                  <col className="w-48 min-w-[12rem]" />
                  {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <col key={d} />)}
                </colgroup>
                <thead>
                  <tr>
                    <th className="border border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 w-48 min-w-[12rem] sticky left-0 z-20"></th>
                    {getRowCells(uniqueMailings[0] || '', month.value, days).map((cell, idx) => {
                      if (cell.day === null) {
                        return <th key={`empty-${idx}`} className="border border-gray-600 bg-white dark:bg-gray-800"></th>;
                      }
                      const isWknd = isWeekend(cell.day, month.value);
                      return (
                        <th
                          key={cell.day}
                          className={`border border-gray-600 border-b-2 h-8 text-center ${isWknd ? 'bg-red-600 text-white' : 'bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100'}`}
                        >
                          {cell.day}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {uniqueMailings.map((mailingName) => {
                    const cells = getRowCells(mailingName, month.value, days);
                    return (
                      <tr key={mailingName} className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                        <td className="border-r-2 border-b border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 font-medium px-2 py-1 truncate sticky left-0 z-10 w-48 min-w-[12rem] text-xs h-10 align-middle">
                          {mailingName}
                        </td>
                        {cells.map((cell, idx) => {
                          if (cell.day === null) {
                            return (
                              <td
                                key={`empty-${idx}`}
                                className="border border-gray-400 h-10 bg-white dark:bg-gray-800"
                              ></td>
                            );
                          }
                          const isWknd = isWeekend(cell.day, month.value);
                          return (
                            <td
                              key={cell.day}
                              className={`border border-gray-400 h-10 align-middle p-0.5 relative group ${isWknd ? 'bg-red-100 dark:bg-red-900/30' : 'bg-white dark:bg-gray-800'}`}
                            >
                              {cell.events.length > 0 && cell.events.map(ev => (
                                <div
                                  key={ev.id}
                                  onClick={(e) => handleEventClick(ev, e)}
                                  className={`w-full h-full ${getStatusColor(ev.visual_design_status || ev.text_content_status || 'pending')} text-white text-[8px] px-0.5 py-0.5 rounded cursor-pointer hover:opacity-80 flex items-center justify-center font-semibold`}
                                  title={`${ev.mailing_name} - ${ev.visual_design_status || ev.text_content_status || 'pending'}`}
                                >
                                  {ev.mailing_name?.substring(0, 4) || ''}
                                </div>
                              ))}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
      {loading && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg font-semibold">İşlem Yapılıyor...</div>
        </div>
      )}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 2px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: rgba(156, 163, 175, 0.5);
          border-radius: 20px;
        }
      `}</style>
    </div>
  );
};

export default MailingCalendar;
